module.exports = __webpack_public_path__ + "img/tauko_design.dce62248.jpg";